import Model from './model.js';

export default class SocialMedia extends Model
{
    constructor(id, personId, facebookUrl, facebookUser, instagramUrl, instagramUser){ 
        super()
        this.id             = id ?? 0;
        this.personId       = personId;
        this.facebookUrl    = facebookUrl;
        this.facebookUser   = facebookUser;
        this.instagramUrl   = instagramUrl;
        this.instagramUser  = instagramUser;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        return {
            facebookUrl:    this.facebookUrl ?? null,
            facebookUser:   this.facebookUser ?? null,
            instagramUrl:   this.instagramUrl ?? null,
            instagramUser:  this.instagramUser ?? null
        };
    }
        
    mapToCreate(){
        let data = this.mapToUpdate();
        data.personId = this.personId ?? null;
        return data;
    }
}

